import React from 'react';
import {
  FormPanel,
  FormTextField,
  FormSelect,
  FormCheckbox,
  FormAutocomplete,
  FormLocalDateTimeField,
  useFormSelector,
} from '@eas/common-web';
import { FormattedMessage } from 'react-intl';
import { useLanguages } from 'src/list-source/languages';
import { useNonStandardStates, useProcessStates } from './import-request-api';
import { ImportRequest, RequestNonStandardState } from '@models';
import { ProcessState } from '@enums';

export function Fields() {
  const languages = useLanguages();
  const processStates = useProcessStates();
  const nonStandardStates = useNonStandardStates();

  const { nonStandardStates: nonStandardStatesData, processState } =
    useFormSelector((data: ImportRequest) => ({
      nonStandardStates: data.nonStandardStates,
      processState: data.processState,
    }));
  const hasError = hasBlockingError(nonStandardStatesData, processState);

  return (
    <>
      <FormPanel
        label={
          <FormattedMessage
            id="TAPIS__IMPORT_REQUEST__DETAIL__PANEL_TITLE__BASIC_INFO"
            defaultMessage="Základní informace"
          />
        }
        summary={
          hasError && (
            <span style={{ color: 'red', fontWeight: 400 }}>
              Dávka je blokována chybami
            </span>
          )
        }
      >
        <FormSelect
          name="processState"
          source={processStates}
          valueIsId={true}
          label={
            <FormattedMessage
              id="TAPIS__IMPORT_REQUEST__DETAIL__FIELD_LABEL__PROCESS_STATE"
              defaultMessage="Stav procesu"
            />
          }
        />
        <FormTextField
          name="importedCount"
          label={
            <FormattedMessage
              id="TAPIS__IMPORT_REQUEST__DETAIL__FIELD_LABEL__IMPORTED_COUNT"
              defaultMessage="Počet importovaných záznamů"
            />
          }
        />
        <FormCheckbox
          name="incremental"
          label={
            <FormattedMessage
              id="TAPIS__IMPORT_REQUEST__DETAIL__FIELD_LABEL__INCREMENTAL"
              defaultMessage="Inkrementální import"
            />
          }
        />
        <FormAutocomplete
          name="nonStandardStates"
          source={nonStandardStates}
          label={
            <FormattedMessage
              id="TAPIS__IMPORT_REQUEST__DETAIL__FIELD_LABEL__NON_STANDARD_STATE"
              defaultMessage="Nestandardní stavy"
            />
          }
          labelMapper={(item) => `${item.state?.name} - počet: ${item.count}`}
          //  DisabledComponent={CustomAutocompleteDisabledComponent}
          multiple
          multiline
        />
        <FormLocalDateTimeField
          name="started"
          label={
            <FormattedMessage
              id="TAPIS__IMPORT_REQUEST__DETAIL__FIELD_LABEL__STARTED"
              defaultMessage="Spuštěno"
            />
          }
        />
        <FormLocalDateTimeField
          name="finished"
          label={
            <FormattedMessage
              id="TAPIS__IMPORT_REQUEST__DETAIL__FIELD_LABEL__FINISHED"
              defaultMessage="Ukončeno"
            />
          }
        />
        <FormTextField
          name="importedCount"
          label={
            <FormattedMessage
              id="TAPIS__IMPORT_REQUEST__DETAIL__FIELD_LABEL__IMPORTED_COUNT"
              defaultMessage="Počet importovaných záznamů"
            />
          }
        />
      </FormPanel>
      <FormPanel
        label={
          <FormattedMessage
            id="TAPIS__IMPORT_REQUEST__DETAIL__PANEL_TITLE__SOURCE"
            defaultMessage="Zdroj informací"
          />
        }
      >
        <FormTextField
          name="source.label"
          label={
            <FormattedMessage
              id="TAPIS__PARAGRAPH__DETAIL__FIELD_LABEL__SOURCE_LABEL"
              defaultMessage="Název"
            />
          }
        />
        <FormTextField
          name="source.code"
          label={
            <FormattedMessage
              id="TAPIS__PARAGRAPH__DETAIL__FIELD_LABEL__SOURCE_CODE"
              defaultMessage="Kód"
            />
          }
        />

        <FormSelect
          name="source.language"
          source={languages}
          label={
            <FormattedMessage
              id="TAPIS__PARAGRAPH__DETAIL__FIELD_LABEL__SOURCE_LANGUAGE"
              defaultMessage="Jazyk"
            />
          }
          valueIsId={true}
        />
      </FormPanel>
    </>
  );
}

/* const useStyles = makeStyles(() => ({
  disabledComponent: {
    lineHeight: '22px',
    height: 22,
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export function CustomAutocompleteDisabledComponent(props: {
  value: string | null;
  disabled?: boolean;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
}) {
  const classes = useStyles();

  const values = props.value?.split('; ');

  return (
    <>
      {values?.map((value) => (
        <Typography
          key={value}
          variant="body1"
          className={classes.disabledComponent}
          style={{ color: 'red' }}
        >
          {value}
        </Typography>
      ))}
    </>
  );
}
 */

export const hasBlockingError = (
  nonStandardState: RequestNonStandardState[] | undefined,
  processState: ProcessState | undefined
) => {
  return (
    nonStandardState?.some(
      ({ state }) =>
        state?.code === 'FAILED_DOWNLOADING' ||
        state?.code === 'FAILED_PROCESSING'
    ) && processState === ProcessState.RUNNING
  );
};
